import type { PreviewTerminologyDto } from '@goparrot/loyalty-sdk';

export const pluralizeLoyalty = (points: number, pointNames: PreviewTerminologyDto): string =>
  [1, -1].includes(points) ? pointNames.singular : pointNames.plural;
